<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm nhóm sản phẩm</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0"
                outlined
        >
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
              <v-row>
                <v-col
                    cols="12"
                    md="4"
                >
                  <v-text-field
                          v-model="filterForm.keyword"
                          label="Tìm kiếm theo tên nhóm sản phẩm"
                          placeholder="Nhóm sản phẩm..."
                          clearable
                          @keyup.enter="searchProductGroup"
                  />
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                    v-if="!filterForm.schoolLevelId"
                >
                  <v-autocomplete
                          v-model="filterForm.typeIds"
                          :items="types"
                          item-value="id"
                          item-text="name"
                          label="Tìm kiếm loại hình"
                          placeholder="Chọn loại hình"
                          clearable
                          multiple
                  />
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                    v-if="!filterForm.schoolLevelId"
                >
                  <v-autocomplete
                          v-model="filterForm.schoolLevelIds"
                          :items="listSchoolLevelByType"
                          item-value="id"
                          item-text="name"
                          label="Tìm kiếm nhóm ngành"
                          placeholder="Chọn nhóm ngành"
                          clearable
                          :disabled="!filterForm.typeIds || !filterForm.typeIds.length"
                          multiple
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                        class="primary mx-0"
                        @click="searchProductGroup"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>

            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  export default {
    name: 'FilterForm',
    props: {
      filterForm: {
        default: () => ({}),
      },
      schoolLevels: {
        type: Array,
        default: () => {[]}
      },
      types: {
        type: Array,
        default: () => {[]}
      }
    },
    data(){
      return
    },
    watch: {
      'filterForm.typeIds': function(newVal){
        if(newVal){
          // school level list: [1 , 2, 3 ,4]
          // filter school level selected: [1 , 2, 5] -> [ 1, 2 ]
          this.filterForm.schoolLevelIds = this.filterForm.schoolLevelIds.filter(id => this.listSchoolLevelByType.some(school => school.id === id))
        }
      }
    },
    computed:{
      listSchoolLevelByType() {
        if(this.schoolLevels.length > 0 && this.filterForm.typeIds){
            const result = this.schoolLevels.filter(school => this.filterForm.typeIds.includes(school.id)).map(el => {
              return el.schoolLevel
            })
            return  this.filterSchoolLevelExist(result) || []
        } else return []
      }
    },
    methods: {
      searchProductGroup () {
        Bus.$emit('product-group-list-filter', this.filterForm)
      },

      // [ [{id: 1, name: 'Tiểu học' }, {id: 5, name: 'THCS'}], [{id: 1, name: 'Tiểu học' } , {id: 6, name: 'IELTS', code: 'IELTS'}] ]
      // -> [ {id: 1, name: 'Tiểu học' } ,  {id: 5, name: 'THCS'} ,  {id: 6, name: 'IELTS', code: 'IELTS'}]
      filterSchoolLevelExist(schoolLevels){
        return schoolLevels.reduce((acc, curr) => {
          curr.forEach(item => {
            const existing = acc.find(i => JSON.stringify(i) === JSON.stringify(item));
            if (!existing) {
              acc.push(Object.assign({}, item));
            }
          });
          return acc;
        }, [])
      }
    },
  }
</script>
